import styled from 'styled-components'

export const StructuredQualityReport = styled.div`
  > div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    a {
      @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
        width: 100%;
      }
    }

    a {
      margin-top: 10px;
      border: 1px solid ${ (props) => props.theme.colors['icon-grau3'] };
    }
  }
`
